exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".userstable-cssmodule-userstable-component-VNjRB{border:1px solid red}.userstable-cssmodule-userstable-component-VNjRB .userstable-cssmodule-table-fixed-22mzD{table-layout:fixed;width:100%}.userstable-cssmodule-userstable-component-VNjRB .userstable-cssmodule-column-fixed-1fZJ0{word-wrap:break-word;word-break:break-all}", ""]);

// exports
exports.locals = {
	"userstable-component": "userstable-cssmodule-userstable-component-VNjRB",
	"table-fixed": "userstable-cssmodule-table-fixed-22mzD",
	"column-fixed": "userstable-cssmodule-column-fixed-1fZJ0"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/Users/userstable.cssmodule.scss
// module id = 614
// module chunks = 0